export { PostDetail } from './PostDetail';
